export var ControllerTypes;
(function (ControllerTypes) {
    ControllerTypes["search"] = "search";
    ControllerTypes["autocomplete"] = "autocomplete";
    ControllerTypes["finder"] = "finder";
    ControllerTypes["recommendation"] = "recommendation";
})(ControllerTypes || (ControllerTypes = {}));
